<template>
  <div class="flex contact-table-actions">
    <button
      class="block w-full p-1 text-base leading-5 text-left text-gray-400 hover:text-blue-400 transition duration-150 ease-in-out"
      @click.stop="handleClickEvent('edit')">
      <font-awesome-icon :icon="['far', 'pen']"></font-awesome-icon><span class="sr-only">Edit</span>
    </button>
    <button
        class="block w-full p-1 text-base leading-5 text-left text-gray-400 hover:text-blue-400 transition duration-150 ease-in-out"
    >
        <font-awesome-icon :icon="['far', 'eye']"></font-awesome-icon><span class="sr-only">View</span>
    </button>
  </div>
</template>

<script>

export default {
  name: "AutoresponderTableButton",
  emits: ['button-click'],
  data() {
    return {
      eventType: ''
    }
  },
  methods: {
    handleClickEvent(type) {
        if (type === "edit") {
            this.$inertia.visit(route('autoresponder.edit', this.data.id), { method: 'get' });
        }

      this.eventType = type;
      this.$emit('button-click', {
        type: this.eventType,
        data: this.data
      });
    }
  },
  props: {
    meta: {
      type: Object,
      default: () => { }
    },
    name: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => { }
    },
    click: {
      type: Function,
      default: () => { }
    }
  }
}
</script>

<style scoped>
/* .contact-table-actions {
  max-width: 40px;
} */
</style>
